let initial = true;
export const createLogger = (group) => {
    const isEnabled = () => process.env.NODE_ENV === 'development' && !initial;
    const prefix = `%cVfPf [${group}]`;
    const style = 'font-weight: bold;';
    return {
        group: group,
        log: (...log) => {
            if (isEnabled())
                console.log(prefix, style, ...log);
        },
        info: (...log) => {
            if (isEnabled())
                console.info(prefix, style, ...log);
        },
        warn: (...log) => {
            if (isEnabled())
                console.warn(prefix, style, ...log);
        },
        error: (...log) => {
            if (isEnabled())
                console.error(prefix, style, ...log);
        },
        depricated: (...log) => {
            if (isEnabled())
                console.warn(`${prefix} [DEPRICATED]`, style, ...log);
        },
        _init: () => {
            if (process.env.NODE_ENV === 'development' && initial) {
                initial = false;
                console.info(`%c
  Netcompany - VfPf - Development Logger (SHOULD BE DISABLED IN PRODUCTION)  
         _   _      _                                                        
        | \\ | |    | |                                                       
        |  \\| | ___| |_ ___ ___  _ __ ___  _ __   __ _ _ __  _   _           
        | . ' |/ _ \\ __/ __/ _ \\| '_ ' _ \\| '_ \\ / _' | '_ \\| | | |          
        | |\\  |  __/ || (_| (_) | | | | | | |_) | (_| | | | | |_| |          
        |_| \\_|\\___|\\__\\___\\___/|_| |_| |_| .__/ \\__,_|_| |_|\\__, |          
                                          | |                 __/ |          
                                          |_|                |___/           
                                                                             `, 'background: #09193B; color: #FFFFFF; font-weight: bold;');
            }
        },
    };
};
createLogger('')._init();
